import { useContext } from 'react'
import { Textfit } from "react-textfitfix"

import { PassContext } from "../../../pass-context"
import fieldFormatter from "./field-formatter"
import PopupEditor from '../../popup-editor'
import dataSelector from '../../data-selector'

const Field = ({ field, idx }) => {

  try {
    const { model, template, instanceData, scannerInstanceData } = useContext(PassContext)

    const styles = {
      label: {
        color: model.labelColor,
        height: 20
      },
      value: {
        color: model.foregroundColor,
        height: 20
      }
    }

    let labelClasses = "label overflow-hidden text-nowrap uppercase"
    let valueClasses = "value text-sm overflow-hidden items-top"

    if (field.textAlignment === "PKTextAlignmentRight") {
      labelClasses += " text-right"
      valueClasses += " text-right"
    }

    if (field.textAlignment === "PKTextAlignmentCenter") {
      labelClasses += " text-center"
      valueClasses += " text-center"
    }

    let wrapperClasses = "flex flex-col overflow-hidden w-full"

    const itemPath = `headerFields[${idx}]`
    const labelPath = `${itemPath}.label`
    const valuePath = `${itemPath}.value`

    const label = dataSelector({ template, instanceData, scannerInstanceData, path: labelPath })
    const value = dataSelector({ template, instanceData, scannerInstanceData, path: valuePath })

    const resolvedValue = fieldFormatter({ field, value })

    return (
      <div className={wrapperClasses}>
        <div className={labelClasses} style={styles.label}>
          {label}
        </div>

        <Textfit mode="single" className={valueClasses} style={styles.value} min={8} max={20}>
          {resolvedValue}
        </Textfit>
      </div>
    )
  }
  catch (err) {
    throw err
  }
}

const HeaderFields = ({ maxFields }) => {
  try {
    const { template } = useContext(PassContext)

    let fields = template.headerFields

    let permittedFields = fields?.slice(0, maxFields)

    return (
      <PopupEditor title="Header Fields" path="headerFields" colors={{ label: "model.labelColor", value: "model.foregroundColor" }} maxFields={maxFields}>
        <div className="flex flex-row-reverse justify-between w-1/3 gap-2 items-baseline overflow-hidden header editable">
          {permittedFields?.map((f, idx) => <Field key={f.key} field={f} idx={idx} />)}
        </div>
      </PopupEditor>
    )
  }
  catch (err) {
    throw err
  }
}

export default HeaderFields